/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('dialog_blockUserCtrl', ['$scope', '$http', 'NetworkService','MainService', function ($scope, $http, networkService, MainService) {

        $scope.blockUser = function()
        {
            networkService.blockUser(MainService.getEmail());
        }
        $scope.addNote = function()
        {
            //networkService.addNote(MainService.getEmail(), $scope.noteModel);
        }
}])